module.exports = __webpack_public_path__ + "static/media/sandClock.405bc0e0.svg";